import React from 'react';
import FileInput from '../../../components/common/validation/fields/FileInput';
import { classToValidate } from '../../../store/validation';
import { TApiaApiField } from '../ApiaApiHandler';

const ApiaApiFileInput = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);
  const className = React.useMemo(
    () => (element.class ? `handler__file ${element.class}` : 'handler__file'),
    [element.class],
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      ...classToValidate(element.class),
    }),
    [element.class, element.mandatory],
  );

  return (
    <FileInput
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      readOnly={element.readonly}
      disabled={element.disabled}
      validationRules={validationRules}
    />
  );
};

export default React.memo(ApiaApiFileInput);
